const CartActionType = {
    CART_REQUEST:'CART_REQUEST',
    CART_SUCCESS:'CART_SUCCESS',
    CART_FAIL:'CART_FAIL',


    CART_ADD_REQUEST:'CART_ADD_REQUEST',
    CART_ADD_SUCCESS:'CART_ADD_SUCCESS',
    CART_ADD_FAIL:'CART_ADD_FAIL',

    CART_REMOVE_REQUEST:'CART_REMOVE_REQUEST',
    CART_REMOVE_SUCCESS:'CART_REMOVE_SUCCESS',
    CART_REMOVE_FAIL:'CART_REMOVE_FAIL',


    CART_UPDATE_REQUEST:'CART_UPDATE_REQUEST',
    CART_UPDATE_SUCCESS:'CART_UPDATE_SUCCESS',
    CART_UPDATE_FAIL:'CART_UPDATE_FAIL',

    CLEAR_CART_REQUEST:'CLEAR_CART_REQUEST',
    CLEAR_CART_SUCCESS:'CLEAR_CART_SUCCESS',
    CLEAR_CART_FAIL:'CLEAR_CART_FAIL',



    ORDER_CART_REQUEST:'ORDER_CART_REQUEST',
    ORDER_CART_SUCCESS:'ORDER_CART_SUCCESS',
    ORDER_CART_FAIL:'ORDER_CART_FAIL',
    
}


export default CartActionType